import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'scrollbar-hidden overflow-scroll',
    list: 'flex w-fit items-center justify-center rounded-[100px] bg-white/50 p-1.5 backdrop-blur-[9px] transition-transform duration-500 ease-out max-md:mx-2',
    item: 'flex-center flex h-[46px] cursor-pointer text-base leading-[1]',
    button:
      'h-full w-full cursor-pointer rounded-[100px] px-3.5 text-base leading-[1] transition-all duration-200 md:px-5'
  },
  variants: {
    isActive: {
      true: {
        button: 'bg-[#24233D] text-white'
      },
      false: {
        button: 'text-[#24233D] hover:bg-[#24233D]/10'
      }
    }
  }
});
